<script setup>
import { ElPopover } from "element-plus";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores";

const route = useRoute();
const authStore = useAuthStore();
const isSuperAdmin = computed(() => authStore.isSuperAdmin);
const isAccountManager = computed(() => authStore.isAccountManager);
const isSpecificManager = computed(() => authStore.isDealerManager);
const isMultiStoreManager = computed(() => authStore.isMultiStoreManager);
const hasRequiredRoles = computed(() => {
  return (
    isAccountManager.value ||
    isSuperAdmin.value ||
    isSpecificManager.value ||
    isMultiStoreManager.value
  );
});

const baseRoutes = [
  {
    name: "Assignment History",
    to: "/reports?tab=assignment-history",
    urlType: "lms",
  },
  {
    name: "User Progress",
    to: "/reports?tab=course-overview",
    urlType: "lms",
  },
];

const leaderboardsRoute = {
  name: "Leaderboards",
  to: "/leaderboard",
  urlType: "lms",
};

const isReportActive = computed(
  () => route.name === "reports" || route.name === "leaderboard"
);



const completedContentRoute = {
  name: "Completed Content Summary",
  to: "/reports?tab=completed-content-summary",
  urlType: "lms",
};

const myReportCardRoute = {
  name: "My Report Card",
  to: "/my-report-card",
  urlType: "lms",
};

const usageReportRoute = {
  name: "Usage Reports",
  to: "/usage-report-card",
  urlType: "lms",
};

const routes = computed(() => {
  let routes = [];
  if (hasRequiredRoles.value) {
    routes = [...routes, usageReportRoute];
    routes = [...routes, myReportCardRoute];
    routes = [...routes, ...baseRoutes, completedContentRoute, leaderboardsRoute];
  } else {
    routes = [...routes, myReportCardRoute, leaderboardsRoute];
  }

  return routes;
});
</script>
<template>
  <div v-bind="$attrs">
    <el-popover
      :width="230"
      popper-style="padding: 5px !important;z-index: 3000 !important; background-color: #161616"
    >
      <template #reference>
        <a
          class="px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium cursor-pointer"
          :class="{
            'text-kintz-primary-2 border-kintz-primary-2 border-b-2':
              isReportActive,
            'hover:border-kintz-primary-2 border-b-2 border-transparent hover:text-kintz-primary-2 text-kintz-primary-4':
              !isReportActive,
          }"
        >
          Reports
        </a>
      </template>
      <template #default>
        <div class="w-full flex flex-col justify-start items-start">
          <div class="w-full" v-for="(r, index) in routes" :key="index">
            <router-link
              class="w-full px-2 py-2 text-sm flex justify-start items-start break-all break-after-all"
              :class="{
                'text-kintz-primary-2': route.fullPath === r.to,
                'hover:text-kintz-primary-2 text-kintz-primary-4':
                  route.fullPath !== r.to,
              }"
              :to="r.to"
            >
              {{ r.name }}
            </router-link>
          </div>
        </div>
      </template>
    </el-popover>
  </div>
</template>
<style lang="scss" scoped></style>
